import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { PrimaryInput } from '../../components/PrimaryInput';
import { ErrorPopUp } from '../../components/ErrorPopUp';

function isValid(name) {
  // Regular expression to match only alphabetic characters and spaces
  return name.length >= 2;
}
function LastNamePage() {
  const { t } = useTranslation();
  const { steps, currentStep, data, setData, setCurrentStep, trackEvent } =
    useContext(DataContext);
  const onSubmit = () => {
    if (data?.lastname?.length < 2 || !isValid(data?.firstname))
      setData({ ...data, errors: { ...data?.errors, lastname: true } });
    else {
      setCurrentStep(currentStep + 1);
    }
  };
  const inputRef = useRef(null);
  useEffect(() => {
    trackEvent({ nav_to_last_name: 1 });
  }, [trackEvent]);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && data?.lastname?.length > 0) {
      onSubmit();
    }
  };

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        position: 'relative',
      }}
    >
      <ErrorPopUp
        errorText={t('lastNamePage.lastNameFormatError')}
        error={data?.errors?.lastname}
        setError={(v) =>
          setData({ ...data, errors: { ...data?.errors, lastname: v } })
        }
      />

      <Header steps={steps} currentStep={currentStep} />
      <div
        style={{
          marginTop: '83px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
          }}
        >
          {t('lastNamePage.title').replace('<firstname/>', data?.firstname)}
        </Typography>
        <Box sx={{ marginTop: '48px', width: '100%' }}>
          <PrimaryInput
            value={data?.lastname}
            inputRef={inputRef}
            autoFocus
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              if (e.key === 'Enter' && data?.lastname?.length > 0) {
                onSubmit();
                return;
              }
              setData({
                ...data,
                lastname: e?.target?.value,
                errors: { ...data?.errors, lastname: false },
              });
            }}
            sx={{ width: '100%' }}
          />
        </Box>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <button
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
            style={{
              outline: 'none',
              border: 'none',
              borderRadius: '50%',
              width: '57px',
              height: '57px',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
            >
              <rect
                opacity="0.1"
                width="57"
                height="57"
                rx="28.5"
                transform="matrix(-1 0 0 1 57 0)"
                fill="#44546A"
              />
              <path
                d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                stroke="#44546A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <PrimaryButton
            style={{ flex: 1 }}
            disabled={data?.lastname?.length <= 0}
            onClick={onSubmit}
          >
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default LastNamePage;
